module.exports = __webpack_public_path__ + "img/图像21.b96ca287.png";